import { LeftOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CHAT_FLOW_STEPS, setFlowStep } from '@guuru/chat-web';
import DELETE_CHAT_RATING from './mutations/DeleteChatRating';
import ReopenChatCtaTeaser from './ReopenChatCtaTeaser';

const ReviewRateChatInput = function ({ chatId = '' }) {
  const { t } = useTranslation();

  const [deleteChatRating] = useMutation(DELETE_CHAT_RATING);

  const handleGoBackClick = async () => {
    await deleteChatRating({ variables: { id: chatId } });
    setFlowStep(CHAT_FLOW_STEPS.closeChat);
  };

  return (
    <ReopenChatCtaTeaser
      align="middle"
      justify="center"
      type="flex"
      className="chat-input"
      onClick={handleGoBackClick}
    >
      <nav aria-label="Review rating">
        <LeftOutlined aria-hidden="true" />{' '}
        {t('chat:::rateExpertBadGoBack')}{' '}
      </nav>
    </ReopenChatCtaTeaser>
  );
};

ReviewRateChatInput.propTypes = {
  chatId: PropTypes.string,
};

export default ReviewRateChatInput;
